.wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
}
.input {
  position: absolute;
  opacity: 0;
  width: 20px;
  height: 20px;
  margin: 0;
  cursor: pointer;
}
.box {
  width: 20px;
  height: 20px;
  flex: none;
  display: grid;
  place-items: center;
  border: 1.5px solid var(--color-border-strong);
  border-radius: 6px;
  background: var(--color-surface);
  color: transparent;
  transition: background 0.12s, border-color 0.12s;
}
.input:checked + .box,
.input:indeterminate + .box {
  background: var(--color-accent);
  border-color: var(--color-accent);
  color: var(--color-accent-contrast);
}
.input:focus-visible + .box {
  box-shadow: 0 0 0 3px var(--color-focus);
}
.input:disabled + .box {
  opacity: 0.5;
}
.text {
  font-size: var(--text-sm);
}
